import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { logOut, setSession } from '@volta-module-auth/actions';
import { useAxios2 } from '.';

export const useValidateToken = () => {
  const dispatch = useDispatch();
  const [validateToken, loading, status, response, error] = useAxios2(
    '/v1/auth/validate-device-token',
    'post',
    true // withAuthorization true
  );

  useEffect(() => {
    validateToken({ device_token: '-' })
      .then((res) => {
        // Valid
        console.log('[DeviceToken] Valid', res);
      })
      .catch((err) => {
        // Not valid
        console.error('[DeviceToken] Invalid', err);
        dispatch(setSession({ key: 'user', data: null }));
        dispatch(logOut());
      });
  }, []);
};
